import React from "react";
import FilterFrame from "../filters/FilterFrame";
import HotelCrossViewOffers from "./HotelCrossViewOffers";

import { giataOperators, hotelAttributes, stars, views } from "../utils";
import ImageGallery from "react-image-gallery";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaInfoCircle } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs, Autoplay } from "swiper";
import { IconContext } from "react-icons";

import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";

import { useSelector, useDispatch } from "react-redux";
import {
  selectSearch,
  setApicall,
  setInbounddate,
  setOutbounddate,
  setSearchOption,
} from "amadeusredux/lib/searchSlice";

import "react-image-gallery/styles/css/image-gallery.css";

import Select from "react-select";
import { AiOutlineCloseCircle } from "react-icons/ai";

import HotelInfos from "./HotelInfos";
import { getFilters, search } from "amadeusredux/lib/api";
import { setOfferPage } from "amadeusredux/lib/offersSlice";
import {
  getCatalogData,
  getCityInfo,
  setHotelOfferInfos,
  setHotelPage,
} from "amadeusredux/lib/hotelSlice";
import { setView } from "amadeusredux/lib/systemSlice";

import { FaImage, FaHotel, FaFileAlt, FaMapMarkedAlt } from "react-icons/fa";
import axios from "axios";
import { getHost } from "../utils";
import InfoPopup from "../components/InfoPopup";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import ReactMap from "../components/ReactMap";
import { MdCheck } from "react-icons/md";
import SearchParameter from "../searchs/SearchParameter";

import { RiCloseFill } from "react-icons/ri";

import InfoPopupHover from "../components/InfoPopupHover";
import { getAdvertising } from "amadeusredux/lib/propertiesSlice";
import ImagesPopup from "../components/ImagesPopup";

const nf = new Intl.NumberFormat("de-DE");

export default function HotelCrossViewView(props) {
  const { searchFrame } = props;
  const hotel = useSelector((state) => state.hotel.selectedHotel);

  const cityInfo = useSelector((state) => state.hotel.cityInfo);
  const catalogData = useSelector((state) => state.hotel.catalogData);
  const selectedDestination = useSelector(
    (state) => state.search.selectedDestination
  );
  const dispatch = useDispatch();
  const sidebar = useSelector((state) => state.system.sidebar);
  const [clientFilters, setClientFilters] = React.useState({
    excludeTourOperators: [],
  });

  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);

  const [operators, setOperators] = React.useState([]);

  const hotelData = useSelector((state) => state.hotel.hotelData);
  const searchOptions = useSelector(selectSearch);
  const [hotelRegion, setHotelRegion] = React.useState({});

  const [showInfo, setShowInfo] = React.useState();
  const [catIdx, setCatIdx] = React.useState({ value: 0 });

  const [tourOperators, setTouroperators] = React.useState([]);

  const [galleryPopupOpen, setGalleryPopupOpen] = React.useState(false);

  

  const [images800, setImages800] = React.useState([]);
  const [logoImage, setLogoImage] = React.useState("");
  const [heroImage, setHeroImage] = React.useState("");
  const [catalogText, setCatalogText] = React.useState("");
  const [popupOpen, setPopupOpen] = React.useState(false);
  const [popupInfoOpen, setPopupInfoOpen] = React.useState(false);
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewPicture, setPreviewPicture] = React.useState(null);
  const [previewIndex, setPreviewIndex] = React.useState(0);
  const [agbText, setAgbText] = React.useState("");
  const [images, setImages] = React.useState([]);

  const [nav1, setNav1] = React.useState(null);
  const [nav2, setNav2] = React.useState(null);

  const infos = useSelector((state) => state.properties.infos);
  const view = useSelector((state) => state.system.view);
  const hotelOfferInfos = useSelector((state) => state.hotel.hotelOfferInfos);
  const offers = hotelOfferInfos.Offers?.Offer
    ? [...hotelOfferInfos.Offers?.Offer]
    : [];
  const offerId = useSelector((state) => state.hotel.offerId);

  const offer = offers.find((e) => e.OfferID === offerId)
    ? offers.find((e) => e.OfferID === offerId)
    : {};

  let geodata = hotelData.GeoDictionary;

  //console.log(hotelData.GeoDictionary);

  React.useEffect(() => {
    if (offerId) {
      if (document.getElementById("leftSidebar")) {
        dispatch(
          getAdvertising({ view: view, panel: "leftSidebar", offer: offer })
        );
      }

      if (document.getElementById("rightSidebar")) {
        dispatch(
          getAdvertising({ view: view, panel: "rightSidebar", offer: offer })
        );
      }
    }
  }, [offerId]);

  React.useEffect(() => {
    let images = [];

    if (
      catalogData &&
      catalogData[catIdx.value] &&
      Array.isArray(catalogData[catIdx.value].Bildfile)
    ) {
      let size800 = catalogData[catIdx.value].Bildfile.filter(
        (e) => e.$.size === "800"
      );
      let size150 = catalogData[catIdx.value].Bildfile.filter(
        (e) => e.$.size === "150"
      );

      for (let i = 0; i < size800.length && i < size150.length; i++) {
        images.push({
          original: size800[i]._,
          thumbnail: size150[i]._,
          originalWidth: 800,
          originalHeight: 600,
        });
      }
    }

    setImages([...images]);
  }, [catalogData, catIdx]);

  React.useEffect(() => {
    dispatch(getCatalogData({}));
    if (hotel?.HotelLocationRef?.CityID)
      dispatch(getCityInfo({ id: hotel.HotelLocationRef.CityID }));
  }, []);

  React.useEffect(() => {
    if (hotel && hotel.Name) document.title = "Crosscheck " + hotel.Name;
  }, [hotel]);

  React.useEffect(() => {
    let images800 = [];

    if (
      catalogData &&
      catalogData[catIdx.value] &&
      Array.isArray(catalogData[catIdx.value].Bildfile)
    ) {
      let size800 = catalogData[catIdx.value].Bildfile.filter(
        (e) => e.$.size === "800"
      );
      let amount = size800.length;
      if (amount > 10) amount = 10;

      for (let i = 0; i < amount; i++) {
        images800.push({
          original: size800[i]._,
          thumbnail: size800[i]._,
          originalWidth: 640,
          originalHeight: 480,
        });
      }
    }

    setImages800([...images800]);
  }, [catalogData, catIdx]);

  React.useEffect(() => {
    if (Array.isArray(catalogData) && catalogData.length > catIdx.value) {
      if (
        catalogData[catIdx.value] &&
        Array.isArray(catalogData[catIdx.value].Textfile) &&
        catalogData[catIdx.value].Textfile.length > 0
      ) {
        axios
          .post(getHost() + "/giatadata/", {
            url: catalogData[catIdx.value].Textfile[0],
          })
          .then((response) => {
            //console.log(response);
            setCatalogText(response.data);
          });
      } else {
        setCatalogText("");
      }
      if (
        catalogData[catIdx.value] &&
        Array.isArray(catalogData[catIdx.value].AGB) &&
        catalogData[catIdx.value].AGB.length > 0
      ) {
        axios
          .post(getHost() + "/giatadata/", {
            url: catalogData[catIdx.value].AGB[0],
          })
          .then((response) => {
            //console.log(response);
            setAgbText(response.data);
          });
      } else {
        setAgbText("");
      }
    } else {
      setCatalogText("");
      setAgbText("");
    }
  }, [catalogData, catIdx]);

  React.useEffect(() => {
    if (
      hotel &&
      hotel.HotelLocationRef &&
      hotel.HotelLocationRef.RegionID &&
      hotelData &&
      hotelData.GeoDictionary &&
      hotelData.GeoDictionary.Regions &&
      Array.isArray(hotelData.GeoDictionary.Regions.Region)
    ) {
      if (
        hotelData.GeoDictionary.Regions.Region.find(
          (e) => hotel.HotelLocationRef.RegionID === e.RegionID
        )
      ) {
        setHotelRegion({
          ...hotelData.GeoDictionary.Regions.Region.find(
            (e) => hotel.HotelLocationRef.RegionID === e.RegionID
          ),
        });
      }
    }
  }, [hotel, hotelData]);

  React.useEffect(() => {
    let hero = "";
    let logo = "";

    if (
      Array.isArray(catalogData) &&
      catIdx &&
      catIdx.value &&
      catalogData[catIdx.value]
    ) {
      //console.log(catIdx.value);
      let catalogRow = catalogData[catIdx.value];
      if (Array.isArray(catalogRow.Bildfile)) {
        for (let j = 0; j < catalogRow.Bildfile.length; j++) {
          let file = catalogRow.Bildfile[j];
          //console.log(file.$.size + ":" + file.$.typ);
          if (!hero && file.$.size === "800" && file.$.typ === "MOD") {
            hero = file._;
          }
          if (!logo && file.$.typ === "LG") {
            logo = file._;
          }
          if (hero && logo) {
            break;
          }
        }
      }
    }

    if (
      !hero &&
      Array.isArray(catalogData) &&
      catIdx &&
      catIdx.value &&
      catalogData[catIdx.value]
    ) {
      // console.log(catIdx.value);
      let catalogRow = catalogData[catIdx.value];
      if (Array.isArray(catalogRow.Bildfile)) {
        for (let j = 0; j < catalogRow.Bildfile.length; j++) {
          let file = catalogRow.Bildfile[j];
          //console.log(file.$.size + ":" + file.$.typ);
          if (!hero && file.$.size === "800" && file.$.typ === "A") {
            hero = file._;
          }

          if (hero) {
            break;
          }
        }
      }
    }

    if (Array.isArray(catalogData)) {
      for (let i = 0; i < catalogData.length; i++) {
        let catalogRow = catalogData[i];
        if (Array.isArray(catalogRow.Bildfile)) {
          for (let j = 0; j < catalogRow.Bildfile.length; j++) {
            let file = catalogRow.Bildfile[j];
            if (!hero && file.$.size === "800" && file.$.typ === "A") {
              hero = file._;
            }
            if (!logo && file.$.typ === "LG") {
              logo = file._;
            }
            if (hero && logo) {
              break;
            }
          }
        }
        if (hero && logo) {
          break;
        }
      }
    }
    if (!hero) {
      if (Array.isArray(catalogData)) {
        for (let i = 0; i < catalogData.length; i++) {
          let catalogRow = catalogData[i];
          if (Array.isArray(catalogRow.Bildfile)) {
            for (let j = 0; j < catalogRow.Bildfile.length; j++) {
              let file = catalogRow.Bildfile[j];
              if (!hero && file.$.size === "800" && file.$.typ === "W") {
                hero = file._;
              }
              if (hero) {
                break;
              }
            }
          }
          if (hero) {
            break;
          }
        }
      }
    }
    setLogoImage(logo);
    setHeroImage(hero);
  }, [catalogData, catIdx]);

  React.useEffect(() => {
    if (operators && operators.length > 0) {
      setCatIdx(operators[0]);
    }
  }, [operators]);

  React.useEffect(() => {
    let opps = [];
    if (Array.isArray(catalogData)) {
      for (let i = 0; i < catalogData.length; i++) {
        let bFound = false;
        let bOperator = false;
        for (let j = 0; j < opps.length; j++) {
          if (opps[j].id === catalogData[i].VeranstalterID[0]) {
            bFound = true;
            break;
          }
        }
        let giata = giataOperators.find(
          (e) => e.vi === catalogData[i].VeranstalterID[0]
        );
        //console.log(giata.vc);
        /*if (
          giata &&
          (giata.vn.indexOf("Schweiz") > -1 ||
            giata.vn.indexOf("Österreich") > -1)
        ) {
          continue;
        }*/
        /*if (!bFound) {
          for (let j = 0; j < tourOperators.length; j++) {
            //console.log(tourOperators[j].TourOperatorCode);
            if (tourOperators[j].TourOperatorCode === giata.vc) {
              bOperator = true;
              break;
            }
          }
        }*/
        //if (!bFound && bOperator) {
        if (!bFound && !bOperator) {
          opps.push({
            value: i,
            id: catalogData[i].VeranstalterID[0],
            amadeusid: giata ? giata.vc : "",
            label: giata ? giata.vn : catalogData[i].VeranstalterID[0],
          });
        }
      }
    }
    if (Array.isArray(opps))
      opps = opps.sort((a, b) => ("" + a.label).localeCompare(b.label));
    setCatIdx(opps.length > 0 ? opps[0] : { value: 0 });
    setOperators([...opps]);
  }, [catalogData, tourOperators]);

  const changeFilterAndSearch = (property, value) => {
    dispatch(setHotelPage(1));
    dispatch(setSearchOption({ property: property, data: value }));

    search(dispatch, true, false);
  };
  const setOperator = (value) => {
    for (let i = 0; i < operators.length; i++) {
      //console.log(operators,value)
      if (operators[i].amadeusid == value) {
        setCatIdx(operators[i]);
        break;
      }
    }
  };

  const changeClientFilter = (property, value) => {
    dispatch(setSearchOption({ property: property, data: value }));
  };

  let hotelText = catalogText;
  hotelText = hotelText.substring(0, 400);
  hotelText = hotelText.substring(0, hotelText.lastIndexOf(" ") + 1) + " ...";
  const slick_settings_main = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    //fade: true,
    variableWidth: true,
    focusOnSelect: true,
  };

  const slick_settings_popup = {
    dots: false,
    lazyLoad: true,
    centerMode: true,
    centerPadding: "120px",
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 1,
    swipeToSlide: true,
    autoplay: false,
    speed: 200,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    //fade: true,
    variableWidth: true,
    focusOnSelect: true,
  };

  const slick_settings_navigation = {
    dots: true,
    lazyLoad: true,
    infinite: false,
    slidesToShow: 10,
    slidesToScroll: 5,
    swipeToSlide: true,
    initialSlide: 1,
    autoplay: false,
    speed: 2000,
    autoplaySpeed: 50000,
    pauseOnHover: true,
    //fade: true,
    variableWidth: true,
    focusOnSelect: true,
  };
  let hotelAttributesFiltered = [];
  if (Array.isArray(hotelAttributes))
    hotelAttributesFiltered = hotelAttributes.filter((a) => a.hide !== true);

  let ct = 0;

  if (hotel && Array.isArray(hotel.HotelAttributes)) {
    hotel.HotelAttributes.map((e, i) => {
      let fnd = hotelAttributesFiltered.find((a) => i < 10 && e === a.value);
      if (fnd) ct = ct + 1;
    });
  }

  let attributesfill = [];
  if (Array.isArray(hotel.HotelAttributes))
    for (let i = 0; i < 10 - ct; i++) {
      attributesfill.push(0);
    }

  //console.log(cityInfo);

  return (
    <div className="hotelview">
      <InfoPopup
        popupOpen={popupInfoOpen}
        setPopupOpen={(val) => setPopupInfoOpen(val)}
        text={
          Array.isArray(cityInfo) && cityInfo.length > 0
            ? cityInfo[0].description
            : ""
        }
      />

      {sidebar && searchFrame}
      <SearchParameter />

  <Popup
        closeOnDocumentClick={false}
        open={galleryPopupOpen}
        position="center"
        modal
        overlayStyle={{ zIndex: 10000 }}
        onClose={() => {
          setGalleryPopupOpen(false);
        }}
      >
        <ImagesPopup
          hotel={hotel}
          offer={offer}
          setPopupOpen={(val) => setGalleryPopupOpen(val)}
        />
      </Popup>

      <Popup
        open={previewOpen}
        position="center"
        modal
        onClose={() => {
          setPreviewOpen(false);
        }}
      >
        <div className="imgpopup1">
          <div className="imgpopup2" id="imgpopup2">
            <MdNavigateBefore
              className="imgpopupprev"
              onClick={() => {
                if (previewIndex !== 0) {
                  setPreviewPicture(images[previewIndex - 1].original);
                  setPreviewIndex(previewIndex - 1);
                  console.log(previewIndex);
                } else {
                  setPreviewPicture(images[images.length - 1].original);
                  setPreviewIndex(images.length - 1);
                  console.log(previewIndex);
                }
              }}
            />
          </div>
          <div className="imgpopup3">
            <img className="imgpopup" src={previewPicture}></img>
          </div>
          <div className="imgpopup4" id="imgpopup4">
            <MdNavigateNext
              className="imgpopupnext"
              onClick={() => {
                if (previewIndex !== images.length - 1) {
                  setPreviewPicture(images[previewIndex + 1].original);
                  setPreviewIndex(previewIndex + 1);
                  console.log(previewIndex);
                } else {
                  setPreviewPicture(images[0].original);
                  setPreviewIndex(0);
                  console.log(previewIndex);
                }
              }}
            />
          </div>
        </div>
      </Popup>
      <Popup
        closeOnDocumentClick={false}
        open={popupOpen}
        position="center"
        modal
        onClose={() => {
          setThumbsSwiper(null);
          setPopupOpen(false);
        }}
      >
        <div className="hotelinfoframe">
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "50%", paddingLeft: "16px" }}>
              <span className="hotelview3">{hotel.Name}</span>
              &nbsp;
              {offer &&
                offer.OfferServices &&
                stars(
                  offer.OfferServices.Package.Accommodation.HotelOfferCategory *
                    1
                )}
            </div>
            <div className="hotelinfoclose">
              <RiCloseFill
                onClick={() => setPopupOpen(false)}
                style={{ fontSize: "1.5rem", margin: "auto" }}
              />
            </div>
          </div>
          <div className="hotelview18">
            {hotel && hotel.HotelImages && images800.length === 0 && (
              <img alt="alt" src={hotel.HotelImages.LargeImage} />
            )}
            {images.length > 0 && (
              <>
                <div style={{ margin: "10px" }} >
                  <>
                    <Swiper
                      style={{
                        "--swiper-navigation-color": "#fff",
                        "--swiper-pagination-color": "#fff",
                      }}
                      spaceBetween={10}
                      navigation={true}
                      slidesPerView={images.length > 3 ? 3 : images.length}
                      thumbs={{ swiper: thumbsSwiper }}
                      modules={[FreeMode, Navigation, Thumbs]}
                      className="mySwiper2"
                    >
                      {images.length > 0 &&
                        images.map((e, i) => {
                          return (
                            <SwiperSlide>
                              <img alt=""
                                onClick={(evt) => {
                                  
                                  setPreviewPicture(images[i].original);
                                  setPreviewIndex(i);
                                  setPreviewOpen(true);
                                }}
                                src={e.original}
                              />
                            </SwiperSlide>
                          );
                        })}
                    </Swiper>
                    <Swiper
                      style={{ marginTop: "10px" }}
                      onSwiper={setThumbsSwiper}
                      spaceBetween={10}
                      slidesPerView={images.length > 10 ? 10 : images.length}
                      freeMode={true}
                      multipleActiveThumbs={false}
                      watchSlidesProgress={true}
                      modules={[FreeMode, Navigation, Thumbs]}
                      className="mySwiper"
                    >
                      {images.length > 0 &&
                        images.map((e) => {
                          return (
                            <SwiperSlide>
                              <img className="swiperimg" src={e.original} alt="" />
                            </SwiperSlide>
                          );
                        })}
                    </Swiper>
                  </>
                </div>
              </>
            )}

            <Select
              value={catIdx}
              onChange={(val) => {
                setCatIdx(val);
              }}
              isSearchable={false}
              defaultValue={operators[0]}
              options={Array.isArray(operators) ? operators : []}
            />
          </div>
          <HotelInfos
            hotelRegion={hotelRegion}
            hotelOfferInfos={hotelData}
            showInfo={true}
            catIdx={catIdx}
            catalogData={catalogData}
            hotel={hotel}
          />
        </div>
      </Popup>

      <div
        className="hotelviewframe"
        style={{
          marginTop: 16,
          boxSizing: "border-box",
          boxShadow: " 0px 3px 15px 0px rgba(0, 0, 0, 0.1)",
          backgroundColor: "rgba(255,255,255,0.1)",
        }}
      >
        <div className="hotelview1">
          <div className="hotelview2">
            <span className="hotelview3">{hotel.Name}</span>
            &nbsp;
            {offer &&
              offer.OfferServices &&
              stars(
                offer.OfferServices?.Package?.Accommodation
                  ?.HotelOfferCategory * 1
              )}
            <br />
            in{" "}
            {hotel &&
              hotel.HotelLocationRef &&
              Array.isArray(geodata?.Cities?.City) &&
              geodata.Cities.City.find(
                (c) => c.CityID === hotel.HotelLocationRef.CityID
              ) !== undefined &&
              geodata.Cities.City.find(
                (c) => c.CityID === hotel.HotelLocationRef.CityID
              ).Name}{" "}
            ,{" "}
            {hotel &&
              hotel.HotelLocationRef &&
              Array.isArray(geodata?.Regions?.Region) &&
              geodata.Regions.Region.find(
                (c) => c.RegionID === hotel.HotelLocationRef.RegionID
              ) !== undefined &&
              geodata.Regions.Region.find(
                (c) => c.RegionID === hotel.HotelLocationRef.RegionID
              ).Name}
            ,{" "}
            {hotel &&
              hotel.HotelLocationRef &&
              Array.isArray(geodata?.Countries?.Country) &&
              geodata.Countries.Country.find(
                (c) => c.CountryCode === hotel.HotelLocationRef.CountryCode
              ) !== undefined &&
              geodata.Countries.Country.find(
                (c) => c.CountryCode === hotel.HotelLocationRef.CountryCode
              ).Name}{" "}
            &nbsp;
            <FaInfoCircle
              className="offerframe3"
              onClick={() => {
                dispatch(getCityInfo({ id: hotel.HotelLocationRef.CityID }));
                console.log(cityInfo);
                setPopupInfoOpen(true);
              }}
            />
          </div>

          <div style={{ paddingBottom: "16px", paddingTop: "16px" }}>
            {selectedDestination.length > 0 &&
              !selectedDestination[0].HotelID &&
              selectedDestination[0] !== null &&
              1 == 0 && (
                <span
                  className="offerframe9 offerframeback"
                  onClick={() => {
                    dispatch(setOfferPage(1));
                    dispatch(setView(views.offerview));
                    getFilters(dispatch, false);
                    //search(dispatch, false, false);
                    window.scrollTo(0, 0);
                  }}
                >
                  zur Hotelliste
                </span>
              )}
            <InfoPopupHover
              trigger={
                <span
                  style={{ marginRight: 10 }}
                  className="offerframe9"
                  onClick={() => {
                    dispatch(setHotelOfferInfos({}));

                    dispatch(setView(views.hotelclassicview));
                    dispatch(setHotelPage(1));

                    dispatch(setOutbounddate(""));
                    dispatch(setInbounddate(""));
                    /*dispatch(
                      setOutbounddate(
                        offer.OfferServices.Package.Flight.OutboundFlight
                          .FlightDeparture.DepartureDate
                      )
                    );*/
                    dispatch(setApicall("touroperatoroffers"));
                    search(dispatch, true, false);
                    //dispatch(setCatalogData([]));
                    window.scrollTo(0, 0);
                  }}
                >
                  Classicview
                </span>
              }
              content={infos.classicview}
              position={"bottom center"}
            ></InfoPopupHover>
          </div>
        </div>

        {hotel && hotel.HotelImages && images800.length === 0 && (
          <img alt="alt" src={hotel.HotelImages.LargeImage} />
        )}
        {images800.length > 0 && (
          <div>
            <Swiper
              slidesPerView={images.length > 5 ? 5 : images.length}
              spaceBetween={0}
              style={{
                "--swiper-navigation-color": "#fff",
                marginLeft: "5%",
                marginRight: "5%",
                width: "90%",
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              speed={500}
              loop={true}
              navigation={true}
              modules={[FreeMode, Navigation, Autoplay]}
              className="mySwiper2"
            >
              {images800?.length > 0 &&
                images800?.map((e, i) => {
                  return (
                    <SwiperSlide>
                      <img alt=""
                        src={e.original}
                        onClick={(evt) => {
                          //setPreviewPicture(e.original);
                          //setPreviewIndex(i);
                          //setPreviewOpen(true);
                          setGalleryPopupOpen(true);
                        }}
                      />
                    </SwiperSlide>
                  );
                })}
            </Swiper>
            {/*<Swiper
              slidesPerView={10} 
              slidesPerColumn={10} 
              spaceBetween={5}
              onSwiper={setThumbsSwiper}
              loop={true}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Navigation, Thumbs]}
              className="mySwiper"
            >

              {images800.length > 0 &&
                images800.map((e) => {
                  return (
                    <SwiperSlide>
                      <img
                        src={e.thumbnail}
                       
                      />
                    </SwiperSlide>
                  );
                })}



            </Swiper>*/}
            {/*
            <Slider
              {...slick_settings_main}
              slidesToShow={
                images800.length >= slick_settings_main.slidesToShow
                  ? slick_settings_main.slidesToShow
                  : images800.length
              }
              slidesToScroll={
                images800.length >= slick_settings_main.slidesToScroll
                  ? slick_settings_main.slidesToScroll
                  : images800.length
              }
            >
              {images800.length > 0 &&
                images800.map((e) => {
                  return (
                    <div>
                      <img
                        src={e.original}
                        height="200"
                        style={{ marginLeft: 20 }}
                      />
                    </div>
                  );
                })}
              </Slider>*/}
          </div>
        )}
        <div style={{ paddingTop: 20, paddingLeft: 20 }}>
          <div style={{ fontWeight: 800 }}>Ausstattungsmerkmale</div>
          <div
            style={{
              display: "flex",
              flexFlow: "row wrap",
              justifyContent: "space-between",
              paddingTop: 30,
            }}
          >
            {hotel &&
              Array.isArray(hotel.HotelAttributes) &&
              hotel.HotelAttributes.map((e, i) => (
                <>
                  {hotelAttributesFiltered.find(
                    (a) => i < 10 && e === a.value
                  ) && (
                    <div style={{ flex: "20%" }} key={e}>
                      <div style={{ display: "flex" }}>
                        <div style={{ width: 30 }}>
                          {hotelAttributes.find((a) => e === a.value) ? (
                            hotelAttributes.find((a) => e === a.value).icon ? (
                              hotelAttributes.find((a) => e === a.value).icon()
                            ) : (
                              <MdCheck style={{ verticalAlign: "bottom" }} />
                            )
                          ) : (
                            <MdCheck style={{ verticalAlign: "bottom" }} />
                          )}
                        </div>
                        <div style={{}}>
                          {hotelAttributes.find((a) => e === a.value)
                            ? hotelAttributes.find((a) => e === a.value).label
                            : e}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ))}
            {hotel &&
              Array.isArray(hotel.HotelAttributes) &&
              attributesfill.map((e, i) => (
                <>
                  <div style={{ flex: "20%" }} key={i}></div>
                </>
              ))}
          </div>
          <div style={{ fontWeight: 800, paddingTop: 30 }}>Beschreibung</div>
          <div className={"giatatext1"}>
            {catalogText && (
              <div
                className="hotelinfos9"
                dangerouslySetInnerHTML={{
                  __html: hotelText,
                }}
              />
            )}
          </div>
          <span onClick={() => setPopupOpen(true)} className="hotelview21">
            {" "}
            mehr erfahren
          </span>
        </div>
      </div>

      {/*<div className="hotelview14">
        <div className="hotelview15">
          <div className="hotelview16">
            Hotelinfos{" "}
            <span
              className="hotelview17"
              onClick={() => setShowInfo(!showInfo)}
            >
              {!showInfo ? "+" : "-"}
            </span>
          </div>
          {showInfo && (
            <div className="hotelview18">
              <Select
                value={catIdx}
                onChange={(val) => {
                  setCatIdx(val);
                }}
                isSearchable={false}
                defaultValue={operators[0]}
                options={Array.isArray(operators) ? operators : []}
              />
            </div>
          )}

          {showInfo && (
            <HotelInfos
              hotelRegion={hotelRegion}
              hotelOfferInfos={hotelData}
              showInfo={showInfo}
              catIdx={catIdx}
              catalogData={catalogData}
              hotel={hotel}
            />
          )}
        </div>
          </div>*/}
      <div className="hotelview19">
        <div className={sidebar ? "hotelview20" : "hotelview20collapsed"}>
          <FilterFrame
            hotel={true}
            changeFilterAndSearch={changeFilterAndSearch}
            clientFilters={clientFilters}
            changeClientFilter={changeClientFilter}
            travelfilter={true}
            hotelfilter={false}
            tourOperators={tourOperators}
          />
        </div>

        <HotelCrossViewOffers
          clientFilters={clientFilters}
          setOperator={(val) => setOperator(val)}
        />
      </div>
    </div>
  );
}
